export default "__VITE_ASSET__vv2wxqDk__"